import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=969dc3d6&scoped=true"
import script from "./ThankYou.js?vue&type=script&lang=js&external"
export * from "./ThankYou.js?vue&type=script&lang=js&external"
import style0 from "./ThankYou.scss?vue&type=style&index=0&id=969dc3d6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969dc3d6",
  null
  
)

export default component.exports